import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { IpProvider } from "./context/IpContext.jsx";
import { SocketProvider } from "./context/SocketContext.jsx";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <IpProvider>
    <SocketProvider>
      <App />
    </SocketProvider>
  </IpProvider>
);
